export default __webpack_public_path__ + "static/KeywordResearch_01_04-92ba5722b57ec6aa827aead8925e1c09.webp";